import React from 'react';
import classes from './StatusTag.module.css';

export interface StatusTagProps {
  isActive: boolean;
  activeText: string;
  inactiveText: string;
}

/**
 * Displays status as a colored tag (green for active, gray for inactive)
 */
export const StatusTag: React.FC<StatusTagProps> = ({ isActive, activeText, inactiveText }) => {
  return (
    <span className={isActive ? classes.statusActive : classes.statusInactive}>
      {isActive ? activeText : inactiveText}
    </span>
  );
};
